import React, { useEffect, useState, KeyboardEvent } from 'react';
import { Paper, Card, TextField, IconButton } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';
import { ChatRoomProps, Message } from './types';
import './ChatRoom.scss';
import { autoId } from '../../utils/UidGenerator';
import MessageContainer from './MessageContainer';
import strings from '../../resources/strings';

const MAX_MESSAGE_LENGTH = 280;

const ChatRoom: React.FC<ChatRoomProps> = (props) => {
    const [textMessage, setTextMessage] = useState<string>('');

    const scrollToBottom = () => {
        const scrollableChat = document.getElementById('scrollable-chat');
        scrollableChat!.scrollTop = scrollableChat!.scrollHeight;
    };

    useEffect(() => {
        scrollToBottom();
    }, [props.messages]);

    const handleSendMessage = () => {
        if (textMessage.trim() === '') return;
        const newMessage = {
            idFrom: props.userId,
            isRead: false,
            message: textMessage,
            timestamp: new Date().toISOString(),
        } as Message;
        props.sendMessage(newMessage);
        setTextMessage('');
        setTimeout(() => {
            scrollToBottom();
        }, 10);
    };

    const handleKeyPress = (event: KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            handleSendMessage();
        }
    };

    return (
        <div className="chat-content">
            <Paper className="chat-bar">{`Chat z: ${props.interlocutor?.userName ?? ''} (${
                props.interlocutor?.email ?? ''
            })`}</Paper>

            <div className="chat-container">
                <div className="chat-room">
                    <div id="scrollable-chat" className="scrollable-chat">
                        {props.messages?.map((message) => (
                            <MessageContainer
                                key={autoId()}
                                message={message}
                                userId={props.userId}
                                interlocutor={props.interlocutor}
                                coaches={props.coaches}
                            />
                        ))}
                    </div>
                    {props.interlocutor == null && (
                        <div className="alert-container">
                            <h3>{strings.coachPage.chat.noActiveConverastion}</h3>
                        </div>
                    )}
                    <Card className="text-message">
                        <TextField
                            id={'message'}
                            value={textMessage}
                            type="text"
                            variant="standard"
                            placeholder="Type message..."
                            onChange={(event: React.ChangeEvent<HTMLTextAreaElement>) => {
                                setTextMessage(event.target.value);
                            }}
                            onKeyPress={handleKeyPress}
                            fullWidth
                            inputProps={{
                                maxLength: MAX_MESSAGE_LENGTH,
                            }}
                            InputProps={{
                                style: {
                                    height: '4.5rem',
                                    fontSize: '15px',
                                    paddingLeft: '1rem',
                                },
                            }}
                            className="text"
                            autoComplete="off"
                            disabled={props.interlocutor == null}
                        />
                        <div className="send-button">
                            <IconButton aria-label="send" size="large" onClick={() => handleSendMessage()}>
                                <SendIcon fontSize="inherit" color="primary" />
                            </IconButton>
                        </div>
                    </Card>
                </div>
            </div>
        </div>
    );
};

export default ChatRoom;
